import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import { datadogLogs } from "@datadog/browser-logs";
import { applyStickyNavigation } from "../javascript/sticky_navigation";

// Import stylesheets
import "../stylesheets/application.scss";

// Read from a meta tag rather than a global set by an inline <script>, so the
// Content-Security-Policy does not need 'unsafe-inline' for this.
// Spec: SHP-17632
const environmentMeta = document.querySelector('meta[name="app-environment"]');

datadogLogs.init({
  clientToken: "pub883e282c4b8ff9456d688fdbe72fe60f",
  site: "datadoghq.eu",
  forwardErrorsToLogs: true,
  sampleRate: 100,
  service: "cortana-js",
  env: environmentMeta ? environmentMeta.content : undefined,
  beforeSend: (log) => {
    if (log.message.includes("XHR error GET")) {
      return false;
    }
  },
});

// The navigation bar can wrap onto a second line, so sticky elements below it follow its real height.
let navbarObserver;

// Turbolinks swaps the body on every visit, so the setting is applied to the incoming body too.
document.addEventListener("turbolinks:before-render", (event) => {
  applyStickyNavigation(event.data.newBody);
});

document.addEventListener("turbolinks:load", () => {
  applyStickyNavigation(document.body);

  if (navbarObserver) navbarObserver.disconnect();

  const navbar = document.querySelector("body > nav.navbar-dark");
  if (!navbar) return;

  navbarObserver = new ResizeObserver(() => {
    document.documentElement.style.setProperty("--navbar-height", `${navbar.offsetHeight}px`);
  });
  navbarObserver.observe(navbar);
});

Rails.start();
Turbolinks.start();

Turbolinks.Visit.prototype.performScroll = function () {
  if (!this.scrolled) {
    if (this.action == "replace") {
      // do nothing
    } else if (this.action == "restore") {
      this.scrollToRestoredPosition() || this.scrollToTop();
    } else {
      this.scrollToAnchor() || this.scrollToTop();
    }
    this.scrolled = true;
  }
};

import "../javascript/legacy/";
import "../javascript/controllers";
